module.exports = __webpack_public_path__ + "static/media/collage_5.c7170620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_5.jpg
// module id = 2259
// module chunks = 0